import { PageContent } from "../../pages/templates/PageLayout";

const content: PageContent = {
  style: "darkGradient",
  sections: [
    {
      type: "FormSection",
      title: "We’d love to hear from you",
      subtitle:
        "We make it easier for your team to manage, share, and engage with your digital brand assets.",
      badge: "Contact us",
      form: "general",
      style: "darkGradient",
      position: { mb: "none", pb: "xxxl" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xl" } },
    { type: "TestimonialSection" },
    {
      type: "CtaSection",
      title: "Build your first kit in 5 minutes or less",
      body: "Organize, store, find, and share your brand assets in one library, from anywhere.",
    },
  ],
};

export default content;
